import { PaysafeEventHandler } from './paysafe-event-handler.type';

export type PaysafeFieldEvent = (eventHandler: PaysafeEventHandler) => void;
